export default {
  generic: {
    enlarge: 'Klik op de foto om te vergroten',
  },
  pages: {
    home: {
      location: 'ligging',
      see_all_gites: 'Bekijk alle accomodaties',
      see_all_massages: 'Alle massages',
      domain: {
        view_domain: 'Ontdek het domein',
      },
    },
    wellness: {
      all_massages: 'Alle massages',
    },
    contact: {
      location: 'Ligging',
      contact: 'Neem contact op',
      name: 'Naam en voornaam',
      email: 'Emailadres',
      telephone: 'Telefoonnummer',
      message: 'Bericht',
      send: 'Versturen',
      required: 'verplicht',
      reachability: 'Bereikbaarheid',
    },
  },
  gites: {
    overview: {
      crumb: 'Gîtes en lodges',
      title: 'Onze vakantiegîtes en lodges',
      discover: 'Ontdek',
    },
    detail: {
      pictures: "Foto's",
      facilities: 'Faciliteiten',
      book_directly: 'Meteen boeken',
      from: 'Aankomst',
      to: 'Vertrek',
      show_availability: 'Toon beschikbaarheid',
      availability: 'Bekijk de beschikbaarheid van',
      virtual_tour: 'Virtuele tour',
    },
  },
  footer: {
    name: "Aux Quatrefeuilles d'Oc",
    help: 'Algemene informatie',
    social: 'Vind ons terug op',
    partner: 'Officiële partner van',
    reachable: 'Te bereiken op',
    copyright: 'Copyright',
    rights: 'Alle rechten voorbehouden',
  },
  components: {
    map: {
      calculate_route: 'Bereken mijn route',
      view_on_google_maps: 'Bekijk op Google Maps',
    },
    reviews: {
      title: 'Wat zegt de rest?',
      more: 'Ontdek meer beoordelingen!',
    },
    widget: {
      search: 'Bekijk beschikbaarheid',
      arrival: 'Aankomst',
      and: 'en',
      departure: 'Vertrek',
      close: 'Sluiten',
    },
  },
  groups: {
    more_information: 'Meer informatie',
    more_information_body:
      'Neem contact op met ons voor meer informatie, of een gedetailleerde prijsofferte.',
  },
  error: {
    main_title: 'Pagina niet gevonden',
    title:
      'De pagina kon niet worden geladen. Ververs uw browser om de pagina opnieuw te laden. Als het probleem blijft voordoen, neem dan contact op.',
    body: 'Terug naar home',
  },
}
